<template>
    <modal
        :footerClass="'modal-footer'"
        :checkClass="'modal-check'"
        :politicaClass="'modal-politica'"
        :showModal="isShowingTermo"
        class="modal-termosdeuso"
    >
        <alert-container :messages="msgs" />
        <div slot="title">
            <h2>{{ $t('termos-de-uso') }}</h2>
        </div>
        <div slot="body" style="padding: 0 2.5rem">
            <p>{{ $t('termos-de-uso-body') }}</p>
        </div>
        <br />
        <div slot="politica" class="modal-politica" style="padding: 1rem 2.5rem 0">
            <v-textarea
                class="termo-text"
                :rows="25"
                :value="$store.state.user.textoPrivacidade"
                readonly
            >
            </v-textarea>
        </div>
        <div slot="check" class="modal-check mb-3">
            <b-checkbox type="is-primary" v-model="checkbox">
                {{ $t('check-termo') }}
            </b-checkbox>
        </div>

        <div slot="footer" class="modal-footer">
            <button
                class="save-btn mr-1 pl-4 pr-4"
                type="button"
                @click="save()"
                :disabled="!checkbox"
                v-tippy
                :title="$t('tooltip-termo')"
            >
                {{ $t('aceito-termo') }}
            </button>

            <button
                class="delete-btn pl-4 pr-4 ml-1"
                type="button"
                @click="confirmNotAcceptTerms()"
            >
                {{ $t('rejeitar-termo') }}
            </button>
        </div>
    </modal>
</template>

<script>
import Modal from './Modal.vue';
import AppService from '@/services/AppService';
import Message from '@/models/Message';

export default {
    props: {
        isShowingTermo: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            service: new AppService(this.$http, this.$router),
            checkbox: false,
            msgs: [],
        };
    },
    components: {
        Modal,
    },
    methods: {
        confirmNotAcceptTerms() {
            this.$root.confirm({
                message: this.$t('termo-checkout'),
                onConfirm: this.confirmNotAccept,
            });
        },
        confirmNotAccept() {
            this.service.doLogout();
        },
        showMessage(type, message) {
            this.msgs.push(new Message(type, message, true));
        },
        save() {
            this.isSaving = true;
            this.service
                .sendTermo()
                .then((r) => {
                    if (r.status == 200) {
                        this.showMessage('success', 'termo-atualizada-com-sucesso');
                        this.$store.state.user.setTermoPrivacidade = 1;
                    } else {
                        this.showMessage('error', 'error-ao-atualizar-termo');
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao salvar termo.`, e);
                    this.showMessage('error', 'error-ao-atualizar-termo');
                })
                .finally(() => {
                    this.isSaving = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.modal-termosdeuso {
    background-color: #6d6d6d60;
}
.modal-check {
    input {
        width: 2%;
    }
    .politica {
        width: 100%;
    }
    .termo-text {
        width: 80%;
    }
}
</style>
